import { WasmLoader } from '@seddi/core';
import { RecolorModule } from '@seddi/ui-recolor';
import { SceneGeometryModule } from '@seddi/ui-three-viewer';
import WaGarmentsGeometry from '@seddi/wa-garments-geometry';
import WaRender from '@seddi/wa-render';

import WaGarmentsGeometryWasm from '@seddi/wa-garments-geometry/lib/index.wasm';
import WaRenderWasm from '@seddi/wa-render/lib/index.wasm';

/**
 * Garment geometry module.
 */
export class GarmentGeometryModule {
  /**
   * Init module.
   */
  static async init() {
    await Promise.all([
      fetch(WaGarmentsGeometryWasm)
        .then(res => res.arrayBuffer())
        .then(arr => WasmLoader.Load(WaGarmentsGeometry, new Uint8Array(arr))),
      fetch(WaRenderWasm)
        .then(res => res.arrayBuffer())
        .then(arr => WasmLoader.Load(WaRender, new Uint8Array(arr))),
    ]);
  }
}

export class AppModule {
  private readonly _sceneGeometry: SceneGeometryModule;

  constructor() {
    this._sceneGeometry = new SceneGeometryModule();
  }

  async init() {
    await GarmentGeometryModule.init();
    await RecolorModule.init();
  }

  async dispose() {
    await RecolorModule.dispose();
  }
}
